import type { GridOptions } from '../../../components/ui/table';
import { commonGridOptions, commonTextFilterParams } from '../../../lib/agGridOptions';
import {
  GRID_PAGE_SIZE,
  GRID_PAGE_SIZE_SELECTOR,
} from '../../../components/shared/agGridCells';
import type { RiskRule } from '../models/types';

export { GRID_PAGE_SIZE, GRID_PAGE_SIZE_SELECTOR };

export const RISK_RULES_GRID_DEFAULT_COL_DEF = {
  suppressAutoSize: true,
  filterParams: {
    ...commonTextFilterParams,
    filterOptions: ['contains'],
  },
};

export const riskRulesGridOptions = {
  ...commonGridOptions,
  suppressRowClickSelection: true,
  getRowId: (params) => params.data.ruleType,
  overlayNoRowsTemplate:
    '<span class="text-sm text-muted-foreground">No rules returned for this acquirer.</span>',
} satisfies GridOptions<RiskRule>;
